import { Grid } from '@mui/material';
import AryModal from 'framework/base/components/AryModal';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import BuyCurrencyBase from '../trade-currency-redesign/buy-currency-base/BuyCurrencyBase';
import SellCurrencyBase from '../trade-currency-redesign/sell-currency-base/SellCurrencyBase';

const TradeCurrencyModal = ({
  open,
  handleClose,
  tradeType,
  refetchData,
  tradeCurrencyData,
  handleChangeCustomerAccountNumber,
  handleChangeBankAccountId,
  transactionId,
  accountNumber,
  bankAccountId
}) => {
  const { t } = useTranslation();

  const [buyConfirmLoading, setBuyConfirmLoading] = useState(false);
  const [sellConfirmLoading, setSellConfirmLoading] = useState(false);

  function generateModalTitle(type) {
    if (type === 'buy') {
      return t('Buy Currency');
    }
    if (type === 'sell') {
      return t('Sell Currency');
    }
    return null;
  }
  return (
    <AryModal
      title={generateModalTitle(tradeType)}
      open={open}
      handleClose={() => {
        handleClose();
        refetchData();
      }}
      width="70rem"
      noCloseOnOutsideClicked
      footer={{
        defaultButton: {
          text: tradeType === 'buy' ? t('Confirm Buy') : t('Confirm Sell'),
          type: 'submit',
          form: tradeType === 'buy' ? 'buy-currency' : 'sell-currency',
          loading: tradeType === 'buy' ? buyConfirmLoading : sellConfirmLoading
        }
      }}
    >
      <Grid item xs={12}>
        {tradeType === 'buy' && (
          <BuyCurrencyBase
            handleChangeCustomerAccountNumber={
              handleChangeCustomerAccountNumber
            }
            handleChangeBankAccountId={handleChangeBankAccountId}
            closeParentModal={() => {
              handleClose();
              refetchData();
            }}
            transactionId={transactionId}
            tradeCurrencyData={tradeCurrencyData}
            accountNumber={accountNumber}
            bankAccountId={bankAccountId}
            setParentLoading={setBuyConfirmLoading}
          />
        )}
        {tradeType === 'sell' && (
          <SellCurrencyBase
            handleChangeCustomerAccountNumber={
              handleChangeCustomerAccountNumber
            }
            handleChangeBankAccountId={handleChangeBankAccountId}
            closeParentModal={() => {
              handleClose();
              refetchData();
            }}
            transactionId={transactionId}
            tradeCurrencyData={tradeCurrencyData}
            accountNumber={accountNumber}
            bankAccountId={bankAccountId}
            setParentLoading={setSellConfirmLoading}
          />
        )}
      </Grid>
    </AryModal>
  );
};

export default TradeCurrencyModal;
